import { createTheme } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";
import { yellow, blue } from "@mui/material/colors";

export const theme = createTheme();

export const StyledPaper = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#ffffffef",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.primary,
    width: 350,
    height: 450,
    marginTop: theme.spacing(5),
}));

export const Styleddiv = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    marginTop: theme.spacing(3),
}));

export const StyledButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(yellow[500]),
    backgroundColor: yellow[800],
    "&:hover": {
        backgroundColor: blue[800],
    },


}));